// extracted by mini-css-extract-plugin
module.exports = {"room":"Room_room__1nTqt","room-description":"Room_room-description__NUFV6"};